// This is a local copy of some of the bitmovin interfaces, so that we can see
// what the shapes look like without adding a dependency.
// See: https://cdn.bitmovin.com/player/web/8/docs/enums/core_network.httprequesttype.html
export var BitmovinHttpRequestTypeEnum;
(function (BitmovinHttpRequestTypeEnum) {
    BitmovinHttpRequestTypeEnum["DRM_CERTIFICATE_FAIRPLAY"] = "drm/certificate/fairplay";
    BitmovinHttpRequestTypeEnum["DRM_LICENSE_CLEARKEY"] = "drm/license/clearkey";
    BitmovinHttpRequestTypeEnum["DRM_LICENSE_FAIRPLAY"] = "drm/license/fairplay";
    BitmovinHttpRequestTypeEnum["DRM_LICENSE_PLAYREADY"] = "drm/license/playready";
    BitmovinHttpRequestTypeEnum["DRM_LICENSE_PRIMETIME"] = "drm/license/primetime";
    BitmovinHttpRequestTypeEnum["DRM_LICENSE_WIDEVINE"] = "drm/license/widevine";
    BitmovinHttpRequestTypeEnum["KEY_HLS_AES"] = "key/hls/aes";
    BitmovinHttpRequestTypeEnum["MANIFEST_ADS"] = "manifest/ads";
    BitmovinHttpRequestTypeEnum["MANIFEST_DASH"] = "manifest/dash";
    BitmovinHttpRequestTypeEnum["MANIFEST_HLS_MASTER"] = "manifest/hls/master";
    BitmovinHttpRequestTypeEnum["MANIFEST_HLS_VARIANT"] = "manifest/hls/variant";
    BitmovinHttpRequestTypeEnum["MANIFEST_SMOOTH"] = "manifest/smooth";
    BitmovinHttpRequestTypeEnum["MEDIA_AUDIO"] = "media/audio";
    BitmovinHttpRequestTypeEnum["MEDIA_SEGMENTINDEX"] = "media/segmentindex";
    BitmovinHttpRequestTypeEnum["MEDIA_SUBTITLES"] = "media/subtitles";
    BitmovinHttpRequestTypeEnum["MEDIA_THUMBNAILS"] = "media/thumbnails";
    BitmovinHttpRequestTypeEnum["MEDIA_VIDEO"] = "media/video";
    BitmovinHttpRequestTypeEnum["TIME_SYNC"] = "time/sync";
    BitmovinHttpRequestTypeEnum["UNKNOWN"] = "unknown";
})(BitmovinHttpRequestTypeEnum || (BitmovinHttpRequestTypeEnum = {}));
export var BitmovinStreamType;
(function (BitmovinStreamType) {
    BitmovinStreamType["Dash"] = "dash";
    BitmovinStreamType["Hls"] = "hls";
    BitmovinStreamType["Progressive"] = "progressive";
    BitmovinStreamType["Smooth"] = "smooth";
    BitmovinStreamType["Unknown"] = "unknown";
})(BitmovinStreamType || (BitmovinStreamType = {}));
export var BitmovinTimeMode;
(function (BitmovinTimeMode) {
    BitmovinTimeMode["AbsoluteTime"] = "absolutetime";
    BitmovinTimeMode["RelativeTime"] = "relativetime";
})(BitmovinTimeMode || (BitmovinTimeMode = {}));
export var BitmovinLevelEnum;
(function (BitmovinLevelEnum) {
    BitmovinLevelEnum[BitmovinLevelEnum["debug"] = 0] = "debug";
    BitmovinLevelEnum[BitmovinLevelEnum["log"] = 1] = "log";
    BitmovinLevelEnum[BitmovinLevelEnum["warn"] = 2] = "warn";
    BitmovinLevelEnum[BitmovinLevelEnum["error"] = 3] = "error";
    BitmovinLevelEnum[BitmovinLevelEnum["off"] = 4] = "off";
})(BitmovinLevelEnum || (BitmovinLevelEnum = {}));
